import * as React from 'react';

interface Props {
  children?: React.ReactNode | React.ReactNode[];
}

function BlockQuote({ children }: Props) {
  return (
    <blockquote
      className="my-8 border-l-4 border-yellow-500 bg-yellow-100 dark:bg-gray-700 rounded-lg"
      role="alert"
    >
      <div className="flex items-center px-4 leading-tight">{children}</div>
    </blockquote>
  );
}

export default BlockQuote;
